import { FilterDropdownProps } from 'antd/lib/table/interface'
import CIMSDateRange from 'components/CIMSDateRange'
import { useState } from 'react'
import { Moment } from 'moment'
import { toMoments } from 'utils/toMoment'
import FilterDropdown from './FilterDropdown'

const DateRangeFilter: React.FC<FilterDropdownProps> = ({
  confirm,
  selectedKeys,
  setSelectedKeys,
  clearFilters,
}) => {
  const [, setSearchValue] = useState<[Moment | null, Moment | null] | null>(
    null
  )
  return (
    <FilterDropdown
      confirm={confirm}
      onOk={() =>
        setSearchValue(toMoments(selectedKeys[0].toString().split(',')) ?? null)
      }
      onReset={() => setSearchValue(null)}
      selectedKeys={selectedKeys}
      clearFilters={clearFilters}
    >
      <CIMSDateRange
        preventClear
        value={
          selectedKeys[0]
            ? toMoments(selectedKeys[0].toString().split(','))
            : null
        }
        onChange={(range) => {
          setSelectedKeys(range ? [range.toString()] : [])
        }}
      />
    </FilterDropdown>
  )
}

export default DateRangeFilter
